export default __webpack_public_path__ + "6efb5e5e3789ebbdb3822f6f1fd9de6e.svg";